import { yupResolver } from '@hookform/resolvers/yup';
import { Grid2, Paper, useTheme } from '@mui/material';
import React, { FC, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Input } from '../../../Components/Form/Input/input.component';
import { Loader } from '../../../Components/Loader';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { useToast } from '../../../Hooks/ToasContext';
import { CreateSellersUseCase } from '../../../Usecase/Sellers/create-sellers-usecase';
import { useCreateSellers } from './sellers-create.hook';
import { UpdateSellersUseCase } from '../../../Usecase/Sellers/update-sellers-usecase';
import { ShowSellersUseCase } from '../../../Usecase/Sellers/show-sellers-usecase';
import { Can } from '../../../Components/Can';


  interface ISellersFormProps {
   
    createSellersUseCase: CreateSellersUseCase,
    updateSellersUseCase: UpdateSellersUseCase,
    showSellersUseCase: ShowSellersUseCase
  }
const SellersForm : FC<ISellersFormProps> = ({ createSellersUseCase, updateSellersUseCase, showSellersUseCase }) => {
  
    const { handleAction, loading, errors, register, handleSubmit , control} = useCreateSellers({
      createSellersUseCase,
      updateSellersUseCase,
      showSellersUseCase
    })

    

    return (
      <Can permissions={['menu:sellers:manage']}>  
        <BaseScreen>
            
            <Paper >
                <BaseContentPage 
                    title='Vendedores'
                    breadcrumb={[{ title: 'Vendedores', link: "/sellers-list"}, { title: 'Novo Vendedor'}]}
                >

                {loading && <Loader />}

                <Grid2 container spacing={5} sx={{ marginTop: 2}} component="form" onSubmit={handleSubmit(handleAction)}>


                <Grid2 size={6}>
                    <Input
                        label="Nome"
                        placeholder="Preencha o nome"
                        error={!!errors.name}
                        helperText={errors.name?.message}
                        {...register('name')}
                    />


                </Grid2>

                <Grid2 size={6}>
                  <Input
                      label="E-mail"
                      placeholder="Preencha o e-mail"
                      error={!!errors.email}
                      helperText={errors.email?.message}
                      {...register('email')}
                    />
                </Grid2>           

                <Button type="submit" sx={{ marginTop: '10px', width: '200px' }} isLoading={loading}>
                    SALVAR
                </Button>
                </Grid2>

              </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
        </Can>
    )
}

export { SellersForm };
